import './FileAsset.scss';
import FileIcon from '../misc/FileIcon';
import FileSize from '../misc/FileSize';
import PublishStatusDot from '../misc/PublishStatusDot';
import React from 'react';

class FileAsset extends React.Component {
  render() {
    const asset = this.props.asset;
    const actions = [];

    if (this.props.onSelect) {
      actions.push(
        <a
          className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
          onClick={() => this.props.onSelect(asset)}
          title="Velg denne filen."
          key="select"
        >
          Velg
        </a>
      );
    }

    if (this.props.onEdit) {
      if (actions.length) {
        actions.push(<span key="space-1">&nbsp;</span>);
      }

      actions.push(
        <a
          className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
          onClick={() => this.props.onEdit(asset)}
          title="Endre filens tittel og beskrivelse."
          key="edit"
        >
          <i className="fa fa-pencil" aria-hidden="true"></i> Endre
        </a>
      );
    }

    if (this.props.onRemove) {
      if (actions.length) {
        actions.push(<span key="space-1">&nbsp;</span>);
      }

      actions.push(
        <a
          className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
          onClick={() => this.props.onRemove(asset)}
          title="Fjern denne filen."
          key="remove"
        >
          <i className="fa fa-times" aria-hidden="true"></i> Fjern
        </a>
      );
    }

    return (
      <div className="contentful-asset contentful-asset-file">
        <div className="contentful-asset-toolbar">
          <div className="contentful-asset-title">
            <FileIcon className="contentful-asset-icon" contentType={asset.contentType} />
            <p>{asset.title}</p>
            <p><FileSize bytes={asset.details.size} />&nbsp;&nbsp;<PublishStatusDot entry={asset} /></p>
          </div>
          <div className="contentful-asset-actions">
            {actions}
          </div>
          {this.props.showDescription && asset.description && <div className="contentful-asset-description">
            <p>{asset.description}</p>
          </div>}
        </div>
      </div>
    );
  }
}

FileAsset.defaultProps = {
  disabled: false
};

export default FileAsset;
